<template>
  <div>
    <b-button
      class="exportCsv"
      variant="primary"
      style="
        background-color: #4b8c80;
        width: 5rem;
        height: 1.375rem;
        padding: 0 0.5rem;
        font-family: 'dfyuanstd-w7';
        font-size: 0.875rem;
        font-weight: normal;
      "
      @click="
        (selectPage == 'errorhistory' &&
          (sideBarSelect.processName == '即時維修狀態' ||
            sideBarSelect.processName == '維修履歷')) ||
        (selectPage == 'statisticstable' &&
          sideBarSelect.processName == '統計分析')
          ? exportExcel()
          : exportCsv()
      "
      >匯出Excel</b-button
    >
  </div>
</template>

<script>
import XLSX from "xlsx";
import XLSXStyle from "xlsx-style";
import FileSaver from "file-saver";
import { mapGetters, mapActions } from "vuex";
export default {
  name: "exportCsv",
  data() {
    return {};
  },
  created: function() {},
  components: {},
  computed: {
    ...mapGetters({
      axiosResult: "commonaxios/get_axiosResult",
      selectPage: "getlogin/get_selectPage",
      sideBarSelect: "sideBarTree/get_sideBarSelect",
      exportData: "exportcsv/get_exportData",
      exportDataTitle: "exportcsv/get_exportDataTitle",
      exportFileName: "exportcsv/get_exportFileName",
      exportExcelFileName: "exportcsv/get_exportExcelFileName",
      exportExcelData: "exportcsv/get_exportExcelData"
    })
  },
  watch: {},
  methods: {
    ...mapActions({
      axiosAction: "commonaxios/axiosAction",
      set_alertMsg: "alertmodal/set_alertMsg",
      settimeout_alertModal: "alertmodal/settimeout_alertModal"
    }),
    exportCsv() {
      let vm = this;
      let exportData = vm.exportData;
      let exportDataTitle = vm.exportDataTitle;
      let exportFileName = vm.exportFileName;
      if (exportDataTitle.length == 0 || exportFileName == "") {
        vm.set_alertMsg("無匯出資料");
        vm.settimeout_alertModal();
        return;
      }

      let data = exportData.map(itemsdata => Object.values(itemsdata));

      // 有/n的資料加上""，防止格式異常
      data.forEach((item, index) => {
        item.forEach((arrayItem, arrayIndex) => {
          if (
            data[index][arrayIndex] !== null &&
            typeof data[index][arrayIndex] === "string" &&
            data[index][arrayIndex].indexOf("\n") >= 0
          ) {
            data[index][arrayIndex] = '"' + data[index][arrayIndex] + '"';
          }
        });
      });
      // console.log(data);
      let exportfilename = exportFileName;
      //console.log(data);
      //加入空白，匯出Excel不會改變格式
      // data.forEach((item) => {
      //   item[0] = " " + item[0];
      // });

      //加表頭
      data.unshift(exportDataTitle);
      const csvContent = data.map(row => row.join(",")).join("\n");
      const link = document.createElement("a");
      link.setAttribute(
        "href",
        "data:text/csv;charset=utf-8,%EF%BB%BF" + encodeURI(csvContent)
      );
      link.style = "visibility:hidden";
      link.download = exportfilename + ".csv";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    exportExcel() {
      let vm = this;
      //檔案名稱
      let fileName = vm.exportExcelFileName;

      let fileData = vm.exportExcelData;
      // console.log("fileData:" + fileData);
      // console.log(fileData);
      if (fileData.length == 0 || fileName == "") {
        vm.set_alertMsg("無匯出資料");
        vm.settimeout_alertModal();
        return;
      }
      const wb = XLSX.utils.book_new();

      fileData.forEach(item => {
        let exportData = [];
        exportData.push(item.title);
        item.data.forEach(rowData => {
          exportData.push(rowData);
        });
        // console.log(item.title);
        let ws = XLSX.utils.aoa_to_sheet(exportData);
        if (item.merge != undefined) {
          ws["!merges"] = item.merge;
        }
        if (item.col != undefined) {
          ws["!cols"] = item.col;
        }
        XLSX.utils.book_append_sheet(wb, ws, item.sheetName);

        let range = XLSX.utils.decode_range(wb.Sheets[item.sheetName]["!ref"]);

        let excelStyle = item.excelStyle;
        if (excelStyle == undefined) {
          return;
        }
        for (let R = range.s.r; R <= range.e.r; ++R) {
          for (let C = range.s.c; C <= range.e.c; ++C) {
            let cell_address = { c: C, r: R };
            let cell_ref = XLSXStyle.utils.encode_cell(cell_address);

            // 通用樣式
            if (wb.Sheets[item.sheetName][cell_ref]) {
              let commonStyle = JSON.parse(JSON.stringify(excelStyle.common));
              wb.Sheets[item.sheetName][cell_ref].s = commonStyle;
            }

            // 行數樣式
            if (excelStyle.R[R] !== undefined) {
              if (excelStyle.R[R] == null) {
                if (wb.Sheets[item.sheetName][cell_ref]) {
                  wb.Sheets[item.sheetName][cell_ref].s = {};
                }
                continue;
              }
              let styleKey = Object.keys(excelStyle.R[R]);
              styleKey.forEach(data => {
                wb.Sheets[item.sheetName][cell_ref].s[data] =
                  excelStyle.R[R][data];
              });
            }

            // 欄位樣式
            if (excelStyle.C[C] !== undefined) {
              if (excelStyle.C[C] == null) {
                if (wb.Sheets[item.sheetName][cell_ref]) {
                  wb.Sheets[item.sheetName][cell_ref].s = {};
                }
                continue;
              }
              let styleKey = Object.keys(excelStyle.C[C]);
              styleKey.forEach(data => {
                wb.Sheets[item.sheetName][cell_ref].s[data] =
                  excelStyle.C[C][data];
              });
            }

            // 指定樣式
            if (excelStyle.detail[R + "-" + C] !== undefined) {
              if (excelStyle.detail[R + "-" + C] == null) {
                wb.Sheets[item.sheetName][cell_ref].s = {};
                continue;
              }
              let styleKey = Object.keys(excelStyle.detail[R + "-" + C]);
              styleKey.forEach(data => {
                wb.Sheets[item.sheetName][cell_ref].s[data] =
                  excelStyle.detail[R + "-" + C][data];
              });
            }
          }
        }
      });
      let wbout = XLSXStyle.write(wb, {
        bookType: "xlsx",
        bookSST: false,
        type: "binary"
      });

      const s2ab = s => {
        var buf = new ArrayBuffer(s.length);
        var view = new Uint8Array(buf);
        for (var i = 0; i !== s.length; ++i) view[i] = s.charCodeAt(i) & 0xff;
        return buf;
      };
      FileSaver.saveAs(
        new Blob([s2ab(wbout)], {
          type: "application/octet-stream"
        }),
        fileName + ".xlsx"
      );
    },
    //data reset
    reset(keep) {
      var def = this.$options.data();
      for (var i = 0; i < keep.length; i++) {
        def[keep[i]] = this[keep[i]];
      }
      Object.assign(this.$data, def);
      //https://codepen.io/karimcossutti/pen/ObXyKq
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>



// WEBPACK FOOTER //
// src/components/exportCsv.vue